import { applicationMaintenanceReducers } from './maintenance';
import { applicationResetReducers } from './reset/reducer';
import { applicationSidebarReducers } from './sidebar';
import { authReducers } from './auth/reducer';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { periscopeReducers } from './periscope/update/reducer';
import { hardResetApplicationWatcher, serviceUnavailableErrorWatcher, softResetApplicationWatcher, unauthorizedErrorWatcher } from './sagas';
export const applicationReducers = combineReducers({
    auth: authReducers,
    maintenance: applicationMaintenanceReducers,
    periscope: periscopeReducers,
    reset: applicationResetReducers,
    sidebar: applicationSidebarReducers
});
export const applicationWatchers = combineAllWatchers([
    serviceUnavailableErrorWatcher,
    hardResetApplicationWatcher,
    softResetApplicationWatcher,
    unauthorizedErrorWatcher
]);
